/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useCallback } from 'react';

import useDebounce from 'modules/common/useDebounce';

type Event = { target: { name: string; value: string } };

export default function useDebounceEventHandler(
    name: string,
    eventHandler: (e: Event) => void,
    initialValue = '',
    debounceTime = 1000
) {
    const [fieldValue, setFieldValue] = useState(initialValue);

    const debouncedHandler = useCallback(
        useDebounce(
            (value) =>
                eventHandler({
                    target: {
                        name,
                        value,
                    },
                }),
            debounceTime
        ),
        [eventHandler]
    );

    const handleSetFieldValue = (value: string) => {
        setFieldValue(value);
        debouncedHandler(value);
    };

    return [fieldValue, handleSetFieldValue] as const;
}
